import axios from "axios";

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || (isProduction ? "https://snadmin.enrichinsights.com/api" : "/api");

console.log("[DEBUG] API_BASE_URL:", API_BASE_URL);
console.log("[DEBUG] NODE_ENV:", process.env.NODE_ENV);

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 30000,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    console.log(
      `[API Request] ${config.method.toUpperCase()} ${config.baseURL}${config.url}`,
    );
    return config;
  },
  (error) => {
    console.error("[API Request Error]", error);
    return Promise.reject(error);
  },
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log(`[API Response] ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    if (error.response) {
      console.error("[API Error Response]", {
        status: error.response.status,
        data: error.response.data,
      });
    } else if (error.request) {
      console.error("[API No Response]", error.request);
      error.message = "Network Error - Please check your internet connection";
    }
    return Promise.reject(error);
  },
);

// const API_BASE_URL = 'https://zayverse.admin.enrichinsights.com/api';

// export const API_CONFIG = {
//   baseURL: API_BASE_URL,
// };

// export const fetchWithProxy = async (url, options = {}) => {
//   const fullURL = `${API_CONFIG.baseURL}${url}`;
//   try {
//     const response = await fetch(fullURL, options);
//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
//     return await response.json();
//   } catch (error) {
//     console.error('Error fetching data:', error);
//     throw error;
//   }
// };

// export const api = {
//   baseURL: API_CONFIG.baseURL,
//   fetchWithProxy,
// };
